<app-private-person-info standalone="true" [privatePerson]="legalEntity" *ngIf="isPrivatePerson()"></app-private-person-info>
<app-company-info standalone="true" [company]="legalEntity" *ngIf="!isPrivatePerson()"></app-company-info>
